import { cloneDeep, mergeWith, isEqual, isPlainObject, xor } from 'lodash'

export function copyObject (object) {
  return cloneDeep(object)
}

export function compareObjects (object1, object2) {
  return isEqual(object1, object2)
}

export function isEditedClass (value1, value2) {
  return !isEqual(value1, value2) ? 'is-edited' : ''
}

export function mergeDeep (target, source) {
  return mergeWith(target, source, (objValue, srcValue) => {
    if (Array.isArray(objValue)) {
      return srcValue
    }
  })
}

export function isObject (object) {
  return isPlainObject(object)
}

export function symmetricDifference (array1, array2) {
  return xor(array1, array2)
}
